import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvents = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 21C13.866 21 17 17.866 17 14C17 10.134 13.866 7 10 7C6.13401 7 3 10.134 3 14C3 17.866 6.13401 21 10 21Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0065 21C11.7655 19.8483 13 17.1486 13 14.0019C13 10.8553 11.7626 8.14856 10 7",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99203 21C8.23393 19.8484 7 17.1488 7 14.0023C7 10.8558 8.23755 8.14772 10 7",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.07666 13.0118C4.05398 14.4681 6.77602 15.4531 10.0006 15.4531C13.1777 15.4531 15.8822 14.4352 16.8959 13.0123",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 6V9M15.5 2V5M21.5 7.5H18.5M17 3.5L14 3.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 3L10 7",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEvents);
export default ForwardRef;
